function initStickyAddToCart(container = document) {
  const stickyBar = container.querySelector('[data-sticky-add-to-cart]');

  if (!stickyBar) return;

  if (stickyBar.dataset.initialized === 'true') return;
  stickyBar.dataset.initialized = 'true';

  const scrollOffset = Number(stickyBar.dataset.scrollOffset || 500);

  const quantityInput = stickyBar.querySelector('[data-quantity-input]');
  const minusButton = stickyBar.querySelector('[data-quantity-minus]');
  const plusButton = stickyBar.querySelector('[data-quantity-plus]');

  const variantSelect = stickyBar.querySelector(
    '[data-sticky-variant-select]'
  );

  const variantInput = stickyBar.querySelector(
    '[data-sticky-variant-input]'
  );

  const price = stickyBar.querySelector('[data-sticky-price]');

  const prices = stickyBar.querySelector('[data-sticky-prices]');

  const comparePrice = stickyBar.querySelector(
    '[data-sticky-compare-price]'
  );

  const discount = stickyBar.querySelector(
    '[data-sticky-discount]'
  );

  const addButton = stickyBar.querySelector(
    '[data-sticky-add-button]'
  );

  const buttonText = stickyBar.querySelector(
    '[data-sticky-button-text]'
  );

  function handleScroll() {
    stickyBar.classList.toggle(
      'is-visible',
      window.scrollY >= scrollOffset
    );
  }

  window.addEventListener('scroll', handleScroll, {
    passive: true
  });

  handleScroll();

  if (minusButton && quantityInput) {
    minusButton.addEventListener('click', function () {
      const value = Number(quantityInput.value) || 1;
      quantityInput.value = Math.max(1, value - 1);
    });
  }

  if (plusButton && quantityInput) {
    plusButton.addEventListener('click', function () {
      const value = Number(quantityInput.value) || 1;
      quantityInput.value = value + 1;
    });
  }

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof Shopify.formatMoney === 'function'
    ) {
      return Shopify.formatMoney(cents);
    }

    return (cents / 100).toFixed(2);
  }

  function updateVariant(variant) {
    if (!variant) return;

    const variantId = variant.id;
    const variantPrice = Number(variant.price || 0);
    const variantComparePrice = Number(variant.compareAtPrice || 0);
    const available = Boolean(variant.available);
    const onSale = variantComparePrice > variantPrice;

    if (variantInput) {
      variantInput.value = variantId;
    }

    if (price) {
      price.textContent = formatMoney(variantPrice);
    }

    if (prices) {
      prices.classList.toggle('price--on-sale', onSale);
      prices.classList.toggle('price--sold-out', !available);
    }

    if (comparePrice && onSale) {
      comparePrice.textContent = formatMoney(variantComparePrice);
    }

    if (discount) {
      const percentage = onSale
        ? Math.round(
            ((variantComparePrice - variantPrice) / variantComparePrice) * 100
          )
        : 0;

      discount.textContent = percentage > 0
        ? percentage + discount.dataset.offText
        : '';
    }

    if (addButton) {
      addButton.disabled = !available;
    }

    if (buttonText && addButton) {
      buttonText.textContent = available
        ? addButton.dataset.addText
        : addButton.dataset.soldOutText;
    }
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const option = this.options[this.selectedIndex];
      if (!option) return;

      updateVariant({
        id: option.value,
        price: option.dataset.price,
        compareAtPrice: option.dataset.comparePrice,
        available: option.dataset.available === 'true'
      });
    });
  }

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    stickyBar.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      ({ data: { variant } }) => {
        if (!variant) return;

        if (variantSelect) {
          variantSelect.value = String(variant.id);
        }

        updateVariant({
          id: variant.id,
          price: variant.price,
          compareAtPrice: variant.compare_at_price,
          available: variant.available
        });
      }
    );
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initStickyAddToCart();
});


document.addEventListener('shopify:section:load', function (event) {
  initStickyAddToCart(event.target);
});

document.addEventListener('shopify:section:unload', function (event) {
  const stickyBar = event.target.querySelector('[data-sticky-add-to-cart]');
  stickyBar?.variantChangeUnsubscriber?.();
});
